export default "__VITE_ASSET__BIqtB1VS__"